import {
    CreateUserDto,
    CreateUserOrganizationDto,
    UserOrganizationByDomainDto,
    UserComposedDto,
    CreateUserAccountDto,
    IUserAccount,
} from '@zaplify/users/shared';
import { UserRole } from '@zaplify/users/shared';
import { UserDto } from '@zaplify/users/shared';
import { BaseSdk } from '../../base.sdk';

export class UserSdk extends BaseSdk {
    // @TODO Should be CreateUserAccountDto
    async addUser(user: CreateUserDto) {
        return this.post<UserDto>({ path: `${this.usersPath}/configure`, payload: user });
    }

    async getUserByFirebaseId() {
        return this.get<UserComposedDto>(`${this.usersPath}/me`);
    }

    async getById(id: string) {
        return this.get<UserComposedDto>(`${this.usersPath}/${id}`);
    }

    //@TODO move to zaplifySdk.organizations – Should Not be under zaplifySdk.user right?
    async getUserOrganizationById(id: string) {
        return this.get<CreateUserOrganizationDto>(`${this.userOrganizationsPath}/${id}`);
    }

    async getUserOrganizationByDomain(domain: string) {
        return this.get<UserOrganizationByDomainDto>(`${this.userOrganizationsPath}/by-domain/${domain}`);
    }

    async createUserOrganization(userOrganization: CreateUserAccountDto) {
        return this.post<UserDto>({ path: this.userOrganizationsPath, payload: userOrganization });
    }

    async deactivateUser(userId: string) {
        return this.post<void>({ path: `${this.usersPath}/${userId}/deactivate` });
    }

    async activateUser(userId: string) {
        return this.post<void>({ path: `${this.usersPath}/${userId}/activate` });
    }

    async getUserProfiles(domainName?: string) {
        return this.get<void>(`${this.usersPath}/accounts${domainName ? `?domainName=${domainName}` : ''}`);
    }

    async updateUserRole(userId: string, role: UserRole) {
        return this.put(`${this.usersPath}/${userId}/roles`, { role });
    }

    async getUserAccounts() {
        return this.get<IUserAccount[]>(`${this.usersPath}/accounts?includeInvitations=false`);
    }

    async setUserCreditLimit(userId: string, creditLimit: number) {
        return this.post<void>({ path: `${this.usersPath}/${userId}/credit-limit`, payload: { creditLimit } });
    }

    async getReferralLink(userId: string) {
        return this.get<any>(`${this.usersPath}/referral-link`);
    }
}
